import { Placement, Popover, PopoverInteractionKind } from "@blueprintjs/core";
import React from "react";

interface CustomPopoverProps {
  isOpen: boolean;
  handleInteraction: (state: boolean) => void;
  placement: Placement;
  interactionType: PopoverInteractionKind;
  handleClose?: () => void;
  content?: React.JSX.Element | string;
  children?: React.ReactNode;
  popoverProps?: React.ComponentProps<typeof Popover>;
}

const CustomPopover: React.FC<CustomPopoverProps> = ({
  isOpen,
  handleClose,
  handleInteraction,
  placement = "right",
  interactionType = "click",
  content,
  children,
  popoverProps = {},
}) => {
  
  return (
    <Popover
      {...popoverProps}
      onClose={handleClose}
      interactionKind={interactionType}
      isOpen={isOpen}
      onInteraction={(state) => handleInteraction(state)}
      placement={placement}
      content={content}
    >
      {children}
    </Popover>
  );
};

export default CustomPopover;
